import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ChatMessage } from 'src/app/cyn/chat-module/types/chat-session.types';
import {
    getCachedAgentLinkStatus,
    isAgentLinkReachable,
    normalizeAgentLinkRoute,
} from '../../../core/links/agent-link-validator';
import { AgentBlockComponent } from '../agent-block.base';

export interface LinkBlockPayload {
    route: string;
    label: string;
}

@Component({
    selector: 'chat-link-block',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat-link-block.component.html',
    styleUrls: ['./chat-link-block.component.scss'],
})
export class ChatLinkBlockComponent extends AgentBlockComponent<'link', LinkBlockPayload> {
    @Input() public override message!: ChatMessage<'link', LinkBlockPayload>;

    public get route(): string | null {
        const route = this.message?.payload?.route;

        return route ? normalizeAgentLinkRoute(route) : null;
    }

    public navigate(): void {
        const route = this.route;

        if (route) {
            window.location.assign(route);
        }
    }

    /** @inheritdoc */
    protected override shouldShowPendingState(): boolean {
        return getCachedAgentLinkStatus(this.message?.payload?.route ?? '') === null;
    }

    /** @inheritdoc */
    protected override validateBeforeRender(): Promise<boolean> {
        return isAgentLinkReachable(this.message?.payload?.route ?? '');
    }
}
